let date = 
{
    hello: function()
    {
        console.log("Hello: sy.date");
    },
    
    obj: new Date(),
    date: function()
    {
       var year  = this.obj.getFullYear();
       var month = this.obj.getMonth() + 1;
       var day   = this.obj.getDate();

       month = this.complete( month );
       day   = this.complete( day );

       return year + "-" + month + "-" + day;
    },
    complete: function(i)
    {
        if (i<10)
        {
            i="0" + i;
        }
       return i
    }
};

export default date;